"use strict";
/* Use the real subscription discount from the Shopify selling plan, if there is one. */
if(window.MMB_CFG&&typeof MMB_CFG.subPct==="number"&&MMB_CFG.subPct>0&&MMB_CFG.subPct<1)PRICE.subPct=MMB_CFG.subPct;
